import HeightWidthSetting from './heightWidth'

export default function DimensionsSetting () {
  return <HeightWidthSetting />
}
